import _ from 'lodash';

export default {
  parseApiError,
  parseSocketError,
};

function getStatusCodeErrorMessage (status) {
  if (status === 401) {
    return 'You are not authorized to access this resource'
  } else if (status === 403) {
    return 'You are not allowed to access this resource'
  } else if (status === 404) {
    return 'Resource not found'
  } else {
    return 'Oops, Something went wrong!'
  }
}

function parseSocketError(args) {
  let message = 'Something went wrong!';
  if (args?.payload?.error) {
    const error = args?.payload?.error;
    if (_.isArray(error)) {
      message = _.isObject(error[0]) ? error[0].message : error[0];
    } else if (_.isString(error)) {
      message = error;
    }
  }
  return message;
}

function parseApiError (
  error,
  options = {
    showAuthenticationError: false
  }
) {
  const { data, status } = error;
  let message = getStatusCodeErrorMessage(status);
  if (_.isArray(data.error)) {
    message = _.isObject(data.error[0]) ? data.error[0].message : data.error[0]
  }

  let result = { message, notify: true }
  if (!options.showAuthenticationError) {
    result = {
      ...result,
      notify: error?.status !== 401
    }
  }
  return result
}
